import './App.css';
import PortfolioHome from './views/portfolio/PortfolioHome';
import {Route, Switch} from "react-router";
import ErrorPage from './views/ErrorPage';
import GuessGame from './views/GameX/GuessGame';
import LinkedInHomePage from './clones/views/LinkedInHomePage';
import DrawingHome from './artandcrafts/views/DrawingHome';
import {PortfolioHomepage} from "./views/modern-portfolio/portfolio-homepage";
import {StickyContainer, Sticky} from 'react-sticky';
import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";

function App() {
    const [showRedesignBanner, setShowRedesignBanner] = useState(false);
    const history = useHistory();

    useEffect(() => {
        if (window.location.pathname === '/portfolio-redesign')
            setShowRedesignBanner(false);
    }, [history])

    return (
        <div className="App">
            {
                showRedesignBanner &&
                <StickyContainer>
                    <Sticky>{(style) => <span style={{
                        color: 'wheat',
                        margin: 'auto',
                        textAlign: 'center',
                        display: 'block',
                        paddingBottom: '10px'
                    }}>
                    Portfolio Redesign is in Progress: <a
                        href="/portfolio-redesign">Visit here</a></span>}
                    </Sticky>
                </StickyContainer>
            }

            <Switch>
                <Route path="/" component={PortfolioHomepage} exact/>
                <Route path="/portfolio-redesign" component={PortfolioHome} exact/>
                <Route path="/gameX" component={GuessGame} exact/>
                <Route path="/clones" component={LinkedInHomePage} exact/>
                <Route path="/drawings" component={DrawingHome} exact/>
                <Route component={ErrorPage}/>
            </Switch>
        </div>
    );
}

export default App;
